import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

// Styles
const s = require('./StatusIcon.css');
const successIcon = require('./../../assets/checkmark-green-icon.svg');
const errorIcon = require('./../../assets/minus-orange-icon.svg');
const dimIcon = require('./../../assets/minus-grey-icon.svg');

// Enumerables
export enum EStatusIconType {
    Success,
    Error,
    Dim
}

// Props
interface IStatusIconProps {
    className?: string;
    type: EStatusIconType;
}

// Component
@observer
export class StatusIcon extends React.Component<IStatusIconProps, {}> {
    static get defaultProps(): IStatusIconProps {
        return {
            className: null,
            type: EStatusIconType.Success
        };
    }

    constructor(props: IStatusIconProps) {
        super(props);
    }

    public render() {
        return (
            <span
                className={classNames(s.statusIcon, this.props.className, {
                    success: this.props.type === EStatusIconType.Success,
                    error: this.props.type === EStatusIconType.Error,
                    dim: this.props.type === EStatusIconType.Dim
                })}
            >
                {(this.props.type === EStatusIconType.Error && <img src={errorIcon} width="15" height="15" alt="" />) ||
                    (this.props.type === EStatusIconType.Dim && <img src={dimIcon} width="15" height="15" alt="" />) || (
                        <img src={successIcon} width="13" height="9" alt="" />
                    )}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/indicator/StatusIcon.tsx